import React from 'react';

import { Card, Skeleton } from 'antd';

import './ServiceCardSkeleton.scss';

const ServiceCardSkeleton: React.FC = () => {
  return (
    <Card
      className="my-services-card skeleton-card"
      styles={{ body: { padding: 0, height: '100%' } }}
    >
      <div className="my-services-container">
        <div className="my-services-left-panel skeleton-left-panel">
          <div className="skeleton-logo-placeholder"></div>
        </div>
        <div className="my-services-right-panel">
          <Skeleton.Input
            active
            className="skeleton-title"
            style={{ width: '80%', height: '24px' }}
          />
          <div className="skeleton-description">
            <Skeleton.Input
              active
              style={{ width: '100%', height: '14px', marginBottom: '8px' }}
            />
            <Skeleton.Input
              active
              style={{ width: '90%', height: '14px', marginBottom: '8px' }}
            />
            <Skeleton.Input active style={{ width: '95%', height: '14px' }} />
          </div>
          <div className="my-services-contact-info">
            <div className="skeleton-contact-item">
              <Skeleton.Avatar active size="small" shape="circle" />
              <Skeleton.Input active style={{ width: '70%', height: '14px' }} />
            </div>
            <div className="skeleton-contact-item">
              <Skeleton.Avatar active size="small" shape="circle" />
              <Skeleton.Input active style={{ width: '60%', height: '14px' }} />
            </div>
            <div className="skeleton-contact-item">
              <Skeleton.Avatar active size="small" shape="circle" />
              <Skeleton.Input active style={{ width: '80%', height: '14px' }} />
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default ServiceCardSkeleton;
